module.exports = new __parcel__URL__("Col.5c8064f8.svg").toString();